(function () {
  'use strict';

  /**
   * Animates a number counter from `start` to `end`.
   * Uses easeOutQuart so it rushes fast then snaps to finish.
   * @param {HTMLElement} el      - The element whose textContent is updated
   * @param {number}      start   - Starting value
   * @param {number}      end     - Ending value
   * @param {number}      duration - Total animation duration in ms
   */
  function animateCounter(el, start, end, duration) {
    if (!el) return;
    const range = end - start;
    const startTime = performance.now();

    function easeOutQuart(t) {
      return 1 - Math.pow(1 - t, 2.5); // gentler ease — slower, smoother finish
    }

    function step(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easeOutQuart(progress);
      const current = Math.round(start + range * easedProgress);
      el.textContent = current.toLocaleString('en-IN');

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = end.toLocaleString('en-IN');
        // Mark parent item as done
        el.closest('.number-counter-section__item')?.classList.add('counted');
      }
    }

    requestAnimationFrame(step);
  }

  function initCounters(section) {
    const items = section.querySelectorAll('[data-counter]');
    items.forEach(function (counterEl) {
      const start    = parseInt(counterEl.dataset.start    || '0',   10);
      const end      = parseInt(counterEl.dataset.end      || '100', 10);
      const duration = parseInt(counterEl.dataset.duration || '2500', 10);
      animateCounter(counterEl, start, end, duration);
    });
  }

  function observeSections() {
    const sections = document.querySelectorAll('.number-counter-section');
    if (!sections.length) return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          initCounters(entry.target);
          observer.unobserve(entry.target); // only animate once
        }
      });
    }, { threshold: 0.25 });

    sections.forEach(function (section) { observer.observe(section); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSections);
  } else {
    observeSections();
  }
})();
